import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getProductTemplates({ commit }, payload = {
        paginate: '',
        query: ''}) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_PRODUCT_TEMPLATES_REQUEST')

        return axios
            .get(`/product-templates/product-templates${paginate}${query}`)
            .then(response => {
                commit('GET_PRODUCT_TEMPLATES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_PRODUCT_TEMPLATES_FAILURE')
                handleApiError(error, 'Pobranie listy szablonów produktowych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductTemplate(context, productTemplateId) {
        return axios
            .get(`/product-templates/product-templates/${productTemplateId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych do szablonu produktowego nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createProductTemplate({ commit }, productTemplateData) {
        return axios
            .post('/product-templates/product-templates', productTemplateData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Szablon produktu został dodany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie szablonu produktu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateProductTemplate({ commit }, productTemplateData) {
        return axios
            .put(`/product-templates/product-templates/${productTemplateData.id}`, productTemplateData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Szablon produktowy został zedytowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja szablonu produktu nie powiodła się.')

                return Promise.reject(error)
            })
    },
    deleteProductTemplate({ commit }, productTemplateId) {
        return axios
            .delete(`/product-templates/product-templates/${productTemplateId}`)
            .then(response => {
                commit('DELETE_PRODUCT_TEMPLATE_SUCCESS', productTemplateId)
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Szablon produktu został usunięty.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie szablonu produktu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setProductTemplatesFilters({ commit }, filters) {
        commit('SET_PRODUCT_TEMPLATES_FILTERS', filters)
    },
    clearProductTemplatesFilters({ commit }) {
        commit('CLEAR_PRODUCT_TEMPLATES_FILTERS')
    }
}